import { IconBriefcase, IconBuilding } from '@tabler/icons-react';
import { WelcomeExtensions } from '@ayocore/platform/client/components/Welcome/WelcomeExtensions';

/**
 * Регистрация навигационных CRM-карточек на WelcomePage.
 * Вызывается из CRM bootstrap.ts.
 */
export function registerCrmWelcomeExtensions(): void {
  // Навигационные карточки
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'crm-deals',
    label: 'Сделки',
    icon: IconBriefcase,
    url: '/crm/deals',
    order: 10,
  }));
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'crm-partners',
    label: 'Партнеры',
    icon: IconBuilding,
    url: '/crm/partners',
    order: 20,
  }));
}
